import "./svg/five-percent.svg"

export default {
    name: "five-percent",
    viewBox: "800 800",
}
